import * as React from "react";
import { observer } from "mobx-react";
import { AuthenticationState } from "bernie-context";
import { TripAttachQualificationProps } from "./typings";
import { TripAttachQualificationView } from "./TripAttachQualificationView";
import { TripAttachLoadingView } from "./components/TripAttachLoadingView";
import { withStores } from "stores";
import { Experiment as Experiments, isVariantEnabled } from "src/components/utility/experiment";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { TripAttachQualificationFlexModuleResult } from "typings/microserviceModels/trip-attach-qualification-flex-module";

export enum TripAttachQualificationMipType {
  HOTMIP = "HOTMIP",
  CARMIP = "CARMIP",
}

export const TripAttachQualification = withStores(
  "compositionStore",
  "flexViewModel",
  "flexModuleModelStore"
)(
  observer((props: TripAttachQualificationProps) => {
    const { flexTemplateNode, flexModuleModelStore, context, compositionStore } = props;

    if (!compositionStore) {
      return null;
    }

    if (context.user.authState !== AuthenticationState.AUTHENTICATED) {
      return null;
    }

    const model = flexModuleModelStore.getModel(flexTemplateNode.id) as TripAttachQualificationFlexModuleResult | null;
    if (!model) {
      return null;
    }

    const { SDUI_Trips_Total_Throttle, PWA_Trips_Important_SF, Trips_PWA_SDUI_Rollout, Trip_Hero_Web } = Experiments;

    const isTripsExperimentEnabled = isVariantEnabled(context, PWA_Trips_Important_SF);
    const isTripHeroEnabled = isVariantEnabled(context, Trip_Hero_Web);

    if (isTripHeroEnabled) {
      return null;
    }

    const [isLoading, setLoading] = React.useState(true);

    React.useEffect(() => {
      if (compositionStore) {
        compositionStore
          .updateModule({ fmId: flexTemplateNode.options.fmId })
          .then(() => {
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        setLoading(false);
      }
    }, []);

    const name = flexTemplateNode.options.flexComponentName;

    const { destinationName, tripStartDate, tripEndDate, deepLink, deepLinkMipType, percentageOff, imageData } = model;

    if (!(model && destinationName && tripStartDate && tripEndDate && deepLink && deepLinkMipType && percentageOff)) {
      return isLoading ? <TripAttachLoadingView /> : null;
    }

    if (isTripsExperimentEnabled) {
      return (
        <Viewport>
          <ViewSmall />
          <ViewMedium>
            <TripAttachQualificationView
              deepLink={deepLink}
              deepLinkMipType={deepLinkMipType}
              destinationName={destinationName}
              imageData={imageData}
              moduleName={name}
              percentageOff={percentageOff}
              tripEndDate={tripEndDate}
              tripStartDate={tripStartDate}
            />
          </ViewMedium>
        </Viewport>
      );
    }

    return (
      <Experiment name={SDUI_Trips_Total_Throttle}>
        <ExperimentControl>
          <Experiment name={Trips_PWA_SDUI_Rollout}>
            <ExperimentControl>
              <TripAttachQualificationView
                deepLink={deepLink}
                deepLinkMipType={deepLinkMipType}
                destinationName={destinationName}
                imageData={imageData}
                moduleName={name}
                percentageOff={percentageOff}
                tripEndDate={tripEndDate}
                tripStartDate={tripStartDate}
              />
            </ExperimentControl>
            <ExperimentVariant bucket={1} />
          </Experiment>
        </ExperimentControl>
        <ExperimentVariant bucket={1} />
      </Experiment>
    );
  })
);

export default TripAttachQualification;
